import { Component } from '@angular/core';
import { LayoutModule } from '../../../layout/layout.module';
import { OrdersModule } from '../../../../orders/orders.module';

@Component({
  selector: 'app-orders-dashboard-page',
  standalone: true,
  imports: [LayoutModule, OrdersModule],
  templateUrl: './orders-dashboard-page.component.html',
})
export class OrdersDashboardPageComponent { }
